export default "__VITE_ASSET__D48hx0Ao__"